
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns5e6867bf684c61c40474aebcec4a992cen from './en.yaml'
            i18n.addResourceBundle('en', '5e6867bf684c61c40474aebcec4a992c', flattenObject(ns5e6867bf684c61c40474aebcec4a992cen), true, true);
        
        export default '5e6867bf684c61c40474aebcec4a992c';
    